"use client"

import Link from "next/link"
import { useInfoSitus } from "@/modules/situs/ui/info-situs-provider"
import { KELAS_TITIK } from "./tingkat-status"
import { cn } from "@/shared/lib/utils"

export function IndikatorStatus({ className }: { className?: string }) {
  const { status } = useInfoSitus()
  if (!status) return null

  return (
    <Link href="/status" className={cn("inline-flex items-center gap-2 text-xs font-medium hover:text-white transition-colors", className)}>
      <span className="relative flex h-2 w-2" aria-hidden="true">
        {status.tingkat !== "normal" && <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping", KELAS_TITIK[status.tingkat])} />}
        <span className={cn("relative inline-flex h-2 w-2 rounded-full", KELAS_TITIK[status.tingkat])} />
      </span>
      {status.judul}
    </Link>
  )
}
